import { AbilitiesType } from '../ability';

const rule: AbilitiesType = {
  USE: {},
};

export default rule;
